import { OnInit } from '@angular/core';
var PaymentHelper = /** @class */ (function () {
    function PaymentHelper() {
        this.countryArr = [{
                "code": "AL",
                "name": "ALBANIA"
            },
            {
                "code": "DZ",
                "name": "ALGERIA"
            },
            {
                "code": "AD",
                "name": "ANDORRA"
            },
            {
                "code": "AO",
                "name": "ANGOLA"
            },
            {
                "code": "AI",
                "name": "ANGUILLA"
            },
            {
                "code": "AG",
                "name": "ANTIGUA & BARBUDA"
            },
            {
                "code": "AR",
                "name": "ARGENTINA"
            },
            {
                "code": "AM",
                "name": "ARMENIA"
            },
            {
                "code": "AW",
                "name": "ARUBA"
            },
            {
                "code": "AU",
                "name": "AUSTRALIA"
            },
            {
                "code": "AT",
                "name": "AUSTRIA"
            },
            {
                "code": "AZ",
                "name": "AZERBAIJAN"
            },
            {
                "code": "BS",
                "name": "BAHAMAS"
            },
            {
                "code": "BH",
                "name": "BAHRAIN"
            },
            {
                "code": "BB",
                "name": "BARBADOS"
            },
            {
                "code": "BY",
                "name": "BELARUS"
            },
            {
                "code": "BE",
                "name": "BELGIUM"
            },
            {
                "code": "BZ",
                "name": "BELIZE"
            },
            {
                "code": "BJ",
                "name": "BENIN"
            },
            {
                "code": "BM",
                "name": "BERMUDA"
            },
            {
                "code": "BT",
                "name": "BHUTAN"
            },
            {
                "code": "BO",
                "name": "BOLIVIA"
            },
            {
                "code": "BA",
                "name": "BOSNIA & HERZEGOVINA"
            },
            {
                "code": "BW",
                "name": "BOTSWANA"
            },
            {
                "code": "BR",
                "name": "BRAZIL"
            },
            {
                "code": "VG",
                "name": "BRITISH VIRGIN ISLANDS"
            },
            {
                "code": "BN",
                "name": "BRUNEI"
            },
            {
                "code": "BG",
                "name": "BULGARIA"
            },
            {
                "code": "BF",
                "name": "BURKINA FASO"
            },
            {
                "code": "BI",
                "name": "BURUNDI"
            },
            {
                "code": "KH",
                "name": "CAMBODIA"
            },
            {
                "code": "CM",
                "name": "CAMEROON"
            },
            {
                "code": "CA",
                "name": "CANADA"
            },
            {
                "code": "CV",
                "name": "CAPE VERDE"
            },
            {
                "code": "KY",
                "name": "CAYMAN ISLANDS"
            },
            {
                "code": "TD",
                "name": "CHAD"
            },
            {
                "code": "CL",
                "name": "CHILE"
            },
            {
                "code": "C2",
                "name": "CHINA"
            },
            {
                "code": "CO",
                "name": "COLOMBIA"
            },
            {
                "code": "KM",
                "name": "COMOROS"
            },
            {
                "code": "CG",
                "name": "CONGO - BRAZZAVILLE"
            },
            {
                "code": "CD",
                "name": "CONGO - KINSHASA"
            },
            {
                "code": "CK",
                "name": "COOK ISLANDS"
            },
            {
                "code": "CR",
                "name": "COSTA RICA"
            },
            {
                "code": "CI",
                "name": "CÔTE D’IVOIRE"
            },
            {
                "code": "HR",
                "name": "CROATIA"
            },
            {
                "code": "CY",
                "name": "CYPRUS"
            },
            {
                "code": "CZ",
                "name": "CZECH REPUBLIC"
            },
            {
                "code": "DK",
                "name": "DENMARK"
            },
            {
                "code": "DJ",
                "name": "DJIBOUTI"
            },
            {
                "code": "DM",
                "name": "DOMINICA"
            },
            {
                "code": "DO",
                "name": "DOMINICAN REPUBLIC"
            },
            {
                "code": "EC",
                "name": "ECUADOR"
            },
            {
                "code": "EG",
                "name": "EGYPT"
            },
            {
                "code": "SV",
                "name": "EL SALVADOR"
            },
            {
                "code": "ER",
                "name": "ERITREA"
            },
            {
                "code": "EE",
                "name": "ESTONIA"
            },
            {
                "code": "ET",
                "name": "ETHIOPIA"
            },
            {
                "code": "FK",
                "name": "FALKLAND ISLANDS"
            },
            {
                "code": "FO",
                "name": "FAROE ISLANDS"
            },
            {
                "code": "FJ",
                "name": "FIJI"
            },
            {
                "code": "FI",
                "name": "FINLAND"
            },
            {
                "code": "FR",
                "name": "FRANCE"
            },
            {
                "code": "GF",
                "name": "FRENCH GUIANA"
            },
            {
                "code": "PF",
                "name": "FRENCH POLYNESIA"
            },
            {
                "code": "GA",
                "name": "GABON"
            },
            {
                "code": "GM",
                "name": "GAMBIA"
            },
            {
                "code": "GE",
                "name": "GEORGIA"
            },
            {
                "code": "DE",
                "name": "GERMANY"
            },
            {
                "code": "GI",
                "name": "GIBRALTAR"
            },
            {
                "code": "GR",
                "name": "GREECE"
            },
            {
                "code": "GL",
                "name": "GREENLAND"
            },
            {
                "code": "GD",
                "name": "GRENADA"
            },
            {
                "code": "GP",
                "name": "GUADELOUPE"
            },
            {
                "code": "GT",
                "name": "GUATEMALA"
            },
            {
                "code": "GN",
                "name": "GUINEA"
            },
            {
                "code": "GW",
                "name": "GUINEA-BISSAU"
            },
            {
                "code": "GY",
                "name": "GUYANA"
            },
            {
                "code": "HN",
                "name": "HONDURAS"
            },
            {
                "code": "HK",
                "name": "HONG KONG SAR CHINA"
            },
            {
                "code": "HU",
                "name": "HUNGARY"
            },
            {
                "code": "IS",
                "name": "ICELAND"
            },
            {
                "code": "IN",
                "name": "INDIA"
            },
            {
                "code": "ID",
                "name": "INDONESIA"
            },
            {
                "code": "IE",
                "name": "IRELAND"
            },
            {
                "code": "IL",
                "name": "ISRAEL"
            },
            {
                "code": "IT",
                "name": "ITALY"
            },
            {
                "code": "JM",
                "name": "JAMAICA"
            },
            {
                "code": "JP",
                "name": "JAPAN"
            },
            {
                "code": "JO",
                "name": "JORDAN"
            },
            {
                "code": "KZ",
                "name": "KAZAKHSTAN"
            },
            {
                "code": "KE",
                "name": "KENYA"
            },
            {
                "code": "KI",
                "name": "KIRIBATI"
            },
            {
                "code": "KW",
                "name": "KUWAIT"
            },
            {
                "code": "KG",
                "name": "KYRGYZSTAN"
            },
            {
                "code": "LA",
                "name": "LAOS"
            },
            {
                "code": "LV",
                "name": "LATVIA"
            },
            {
                "code": "LS",
                "name": "LESOTHO"
            },
            {
                "code": "LI",
                "name": "LIECHTENSTEIN"
            },
            {
                "code": "LT",
                "name": "LITHUANIA"
            },
            {
                "code": "LU",
                "name": "LUXEMBOURG"
            },
            {
                "code": "MK",
                "name": "MACEDONIA"
            },
            {
                "code": "MG",
                "name": "MADAGASCAR"
            },
            {
                "code": "MW",
                "name": "MALAWI"
            },
            {
                "code": "MY",
                "name": "MALAYSIA"
            },
            {
                "code": "MV",
                "name": "MALDIVES"
            },
            {
                "code": "ML",
                "name": "MALI"
            },
            {
                "code": "MT",
                "name": "MALTA"
            },
            {
                "code": "MH",
                "name": "MARSHALL ISLANDS"
            },
            {
                "code": "MQ",
                "name": "MARTINIQUE"
            },
            {
                "code": "MR",
                "name": "MAURITANIA"
            },
            {
                "code": "MU",
                "name": "MAURITIUS"
            },
            {
                "code": "YT",
                "name": "MAYOTTE"
            },
            {
                "code": "MX",
                "name": "MEXICO"
            },
            {
                "code": "FM",
                "name": "MICRONESIA"
            },
            {
                "code": "MD",
                "name": "MOLDOVA"
            },
            {
                "code": "MC",
                "name": "MONACO"
            },
            {
                "code": "MN",
                "name": "MONGOLIA"
            },
            {
                "code": "ME",
                "name": "MONTENEGRO"
            },
            {
                "code": "MS",
                "name": "MONTSERRAT"
            },
            {
                "code": "MA",
                "name": "MOROCCO"
            },
            {
                "code": "MZ",
                "name": "MOZAMBIQUE"
            },
            {
                "code": "NA",
                "name": "NAMIBIA"
            },
            {
                "code": "NR",
                "name": "NAURU"
            },
            {
                "code": "NP",
                "name": "NEPAL"
            },
            {
                "code": "NL",
                "name": "NETHERLANDS"
            },
            {
                "code": "NC",
                "name": "NEW CALEDONIA"
            },
            {
                "code": "NZ",
                "name": "NEW ZEALAND"
            },
            {
                "code": "NI",
                "name": "NICARAGUA"
            },
            {
                "code": "NE",
                "name": "NIGER"
            },
            {
                "code": "NG",
                "name": "NIGERIA"
            },
            {
                "code": "NU",
                "name": "NIUE"
            },
            {
                "code": "NF",
                "name": "NORFOLK ISLAND"
            },
            {
                "code": "NO",
                "name": "NORWAY"
            },
            {
                "code": "OM",
                "name": "OMAN"
            },
            {
                "code": "PW",
                "name": "PALAU"
            },
            {
                "code": "PA",
                "name": "PANAMA"
            },
            {
                "code": "PG",
                "name": "PAPUA NEW GUINEA"
            },
            {
                "code": "PY",
                "name": "PARAGUAY"
            },
            {
                "code": "PE",
                "name": "PERU"
            },
            {
                "code": "PH",
                "name": "PHILIPPINES"
            },
            {
                "code": "PN",
                "name": "PITCAIRN ISLANDS"
            },
            {
                "code": "PL",
                "name": "POLAND"
            },
            {
                "code": "PT",
                "name": "PORTUGAL"
            },
            {
                "code": "QA",
                "name": "QATAR"
            },
            {
                "code": "RE",
                "name": "RÉUNION"
            },
            {
                "code": "RO",
                "name": "ROMANIA"
            },
            {
                "code": "RU",
                "name": "RUSSIA"
            },
            {
                "code": "RW",
                "name": "RWANDA"
            },
            {
                "code": "WS",
                "name": "SAMOA"
            },
            {
                "code": "SM",
                "name": "SAN MARINO"
            },
            {
                "code": "ST",
                "name": "SÃO TOMÉ & PRÍNCIPE"
            },
            {
                "code": "SA",
                "name": "SAUDI ARABIA"
            },
            {
                "code": "SN",
                "name": "SENEGAL"
            },
            {
                "code": "RS",
                "name": "SERBIA"
            },
            {
                "code": "SC",
                "name": "SEYCHELLES"
            },
            {
                "code": "SL",
                "name": "SIERRA LEONE"
            },
            {
                "code": "SG",
                "name": "SINGAPORE"
            },
            {
                "code": "SK",
                "name": "SLOVAKIA"
            },
            {
                "code": "SI",
                "name": "SLOVENIA"
            },
            {
                "code": "SB",
                "name": "SOLOMON ISLANDS"
            },
            {
                "code": "SO",
                "name": "SOMALIA"
            },
            {
                "code": "ZA",
                "name": "SOUTH AFRICA"
            },
            {
                "code": "KR",
                "name": "SOUTH KOREA"
            },
            {
                "code": "ES",
                "name": "SPAIN"
            },
            {
                "code": "LK",
                "name": "SRI LANKA"
            },
            {
                "code": "SH",
                "name": "ST. HELENA"
            },
            {
                "code": "KN",
                "name": "ST. KITTS & NEVIS"
            },
            {
                "code": "LC",
                "name": "ST. LUCIA"
            },
            {
                "code": "PM",
                "name": "ST. PIERRE & MIQUELON"
            },
            {
                "code": "VC",
                "name": "ST. VINCENT & GRENADINES"
            },
            {
                "code": "SR",
                "name": "SURINAME"
            },
            {
                "code": "SJ",
                "name": "SVALBARD & JAN MAYEN"
            },
            {
                "code": "SZ",
                "name": "SWAZILAND"
            },
            {
                "code": "SE",
                "name": "SWEDEN"
            },
            {
                "code": "CH",
                "name": "SWITZERLAND"
            },
            {
                "code": "TW",
                "name": "TAIWAN"
            },
            {
                "code": "TJ",
                "name": "TAJIKISTAN"
            },
            {
                "code": "TZ",
                "name": "TANZANIA"
            },
            {
                "code": "TH",
                "name": "THAILAND"
            },
            {
                "code": "TG",
                "name": "TOGO"
            },
            {
                "code": "TO",
                "name": "TONGA"
            },
            {
                "code": "TT",
                "name": "TRINIDAD & TOBAGO"
            },
            {
                "code": "TN",
                "name": "TUNISIA"
            },
            {
                "code": "TM",
                "name": "TURKMENISTAN"
            },
            {
                "code": "TC",
                "name": "TURKS & CAICOS ISLANDS"
            },
            {
                "code": "TV",
                "name": "TUVALU"
            },
            {
                "code": "UG",
                "name": "UGANDA"
            },
            {
                "code": "UA",
                "name": "UKRAINE"
            },
            {
                "code": "AE",
                "name": "UNITED ARAB EMIRATES"
            },
            {
                "code": "GB",
                "name": "UNITED KINGDOM"
            },
            {
                "code": "US",
                "name": "UNITED STATES"
            },
            {
                "code": "UY",
                "name": "URUGUAY"
            },
            {
                "code": "VU",
                "name": "VANUATU"
            },
            {
                "code": "VA",
                "name": "VATICAN CITY"
            },
            {
                "code": "VE",
                "name": "VENEZUELA"
            },
            {
                "code": "VN",
                "name": "VIETNAM"
            },
            {
                "code": "WF",
                "name": "WALLIS & FUTUNA"
            },
            {
                "code": "YE",
                "name": "YEMEN"
            },
            {
                "code": "ZM",
                "name": "ZAMBIA"
            },
            {
                "code": "ZW",
                "name": "ZIMBABWE"
            }];
    }
    PaymentHelper.prototype.ngOnInit = function () {
        //console.log(this.countryArr);
    };
    PaymentHelper.prototype.isValid = function (value) {
        console.log('called with ' + value);
        // accept only digits, dashes or spaces
        if (/[^0-9-\s]+/.test(value))
            return false;
        // The Luhn Algorithm. It's so pretty.
        var nCheck = 0, nDigit = 0, bEven = false;
        value = value.replace(/\D/g, "");
        for (var n = value.length - 1; n >= 0; n--) {
            var cDigit = value.charAt(n), nDigit = parseInt(cDigit, 10);
            if (bEven) {
                if ((nDigit *= 2) > 9)
                    nDigit -= 9;
            }
            nCheck += nDigit;
            bEven = !bEven;
        }
        return (nCheck % 10) == 0;
    };
    PaymentHelper.prototype.paypalCountries = function () {
        return this.countryArr;
    };
    return PaymentHelper;
}());
export { PaymentHelper };
//# sourceMappingURL=payment.js.map